<template>
  <div class="fill-height">
    <!--Header-->
    <div
      style="gap: 8px"
      class="d-flex flex-wrap white px-8 pt-4 align-center justify-space-between"
    >
      <div>
        <h1 class="my-2">{{ $t("contract.list.title") }}</h1>
      </div>

      <div>
        <v-btn
          tile
          @click.stop="$router.push({ name: 'CreateContract' })"
          class="primary"
        >
          {{ $t("create.contract") }}
        </v-btn>
      </div>
    </div>

    <!--Tabs-->
    <div>
      <v-tabs v-model="tabs">
        <v-tab>
          {{ $t("contract.list.tabs.rent") }}
        </v-tab>
        <v-tab>
          {{ $t("contract.list.tabs.sell") }}
        </v-tab>
      </v-tabs>
    </div>

    <div style="position: relative" class="filters_bg px-2">
      <!--Uncomment this to add Search input. You should add "search" data contract-->
      <v-row class="ma-0">
        <v-col class="px-0" cols="4">
          <v-text-field
            flat
            dense
            solo
            class="rounded-r-0 filters_bg grow"
            color="primary"
            v-model="search"
            :label="$t('contract.list.filters.search')"
            prepend-inner-icon="mdi-magnify"
            hide-details
          ></v-text-field>
        </v-col>
        <!-- <v-divider
              class="black"
              vertical></v-divider>
              <v-col 
              class="pa-0"
              cols="2">
              <v-select
              flat
              solo
              dense
              :items="[]"
              multiple
              class="rounded-0 filters_bg shrink"
              :label="$t('contract.list.filters.location')"
              hide-details
              ></v-select>
              </v-col> -->
        <v-divider class="black" vertical></v-divider>
        <v-col class="px-0" cols="2">
          <v-select
            flat
            dense
            solo
            :items="contract_states"
            v-model="filters.state"
            multiple
            class="rounded-0 filters_bg"
            :label="$t('contract.list.filters.state')"
            hide-details
          ></v-select>
        </v-col>
        <v-divider class="black" vertical></v-divider>
        <v-col class="px-0" cols="2">
          <v-autocomplete
            flat
            dense
            solo
            :items="owner_array"
            v-model="filters.owner"
            class="rounded-0 filters_bg"
            :label="$t('contract.list.filters.owners')"
            hide-details
          ></v-autocomplete>
        </v-col>
        <v-divider class="black" vertical></v-divider>
        <v-col class="px-0" cols="2">
          <v-autocomplete
            flat
            dense
            solo
            :items="tenant_array"
            v-model="filters.tenant"
            class="rounded-0 filters_bg"
            :label="$t('contract.list.filters.tenant')"
            hide-details
          ></v-autocomplete>
        </v-col>
      </v-row>
    </div>
    <!--Finish Estates Header-->
    <div
      style="width: fit-content"
      class="px-2 py-1 caption filters_bg rounded-b-lg"
    >
      {{ totalCount }} contratos encontrados
    </div>
    <div class="background px-3 fill-height mt-3">
      <!--Uncomment this to add Search input. You should add "search: '' " data contract-->
      <v-card flat color="transparent">
        <div class="fill-height">
          <div class="text-center" v-if="loading">
            <v-progress-circular
              :size="100"
              :width="7"
              color="primary"
              indeterminate
            ></v-progress-circular>
          </div>
          <List
            v-else
            ref="list"
            :key="tabs"
            @reload="fetchContracts('no-cache')"
            :contracts="contracts"
          />
          <v-col cols="12">
            <div class="text-center">
              <v-pagination v-model="page" :length="pages"> </v-pagination>
              <v-select
                class="per-page-select"
                solo
                :items="[10, 20, 50, 100]"
                v-model="per_page"
              >
              </v-select>
            </div>
          </v-col>
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import { Contracts } from "@/graphql/queries/contract";
import { Contacts } from "@/graphql/queries/directory";
import List from "@/components/contracts/List";

export default {
  //Here you add your component name
  name: "Contracts",
  data() {
    return {
      //Determines what tab is active, beeing 0 the first one and 1 the second.
      tabs: "0",
      search: "",
      loading: false,
      filters: {},
      contract_states: [],
      contracts: [],
      owner_array: [],
      tenant_array: [],
      types: ["rent", "sell"],
      page: 1,
      pages: 1,
      totalCount: 0,
      timer: null,
      per_page: 10
    };
  },
  components: {
    List
  },
  props: {
    success: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  mounted() {
    this.fetchContracts("no-cache", "", {}, true);
    this.fetchOwners();
    this.fetchTenants();
  },

  methods: {
    fetchTenants() {
      this.$apollo
        .query({
          query: Contacts,
          variables: {
            noPaginate: true,
            roles: ["tenant"]
          },
          fetchPolicy: "no-cache"
        })
        .then(res => {
          var tenants = [{ text: "Todos", value: null }];
          var fetched = res.data.contacts.contacts;
          fetched.forEach(tenant => {
            tenants.push({ text: tenant.profile.name, value: tenant.id });
          });

          this.tenant_array = tenants;
        });
    },

    fetchOwners() {
      this.$apollo
        .query({
          query: Contacts,
          variables: {
            noPaginate: true,
            roles: ["owner"]
          },
          fetchPolicy: "no-cache"
        })
        .then(res => {
          var owners = [{ text: "Todos", value: null }];
          var fetched = res.data.contacts.contacts;
          fetched.forEach(owner => {
            owners.push({ text: owner.profile.name, value: owner.id });
          });

          this.owner_array = owners;
        });
    },

    fetchContracts(policy, search = "", filters = {}, firstLoad = false) {
      this.loading = true;

      this.$apollo
        .query({
          query: Contracts,
          variables: {
            search: search,
            filters: filters,
            operationType: this.types[this.tabs],
            page: this.page,
            perPage: this.per_page
          },
          fetchPolicy: policy
        })
        .then(res => {
          this.contracts = res.data.contracts.contracts;
          this.pages = res.data.contracts.pages;

          if (firstLoad) {
            var contractStatesArray = [];
            this.contracts.forEach(a => {
              contractStatesArray.push({
                text: this.$t("contract.list.state." + a.state),
                value: a.state
              });
            });

            this.contract_states = contractStatesArray;
          }

          this.totalCount = res.data.contracts.totalCount;

          this.loading = false;
        });
    }
  },
  watch: {
    tabs() {
      this.fetchContracts("no-cache");
    },
    search: {
      handler() {
        if (this.timer) clearTimeout(this.timer);

        this.timer = setTimeout(() => {
          this.fetchContracts("no-cache", this.search, this.filters);
        }, 500);
      }
    },
    filters: {
      handler() {
        this.fetchContracts("no-cache", this.search, this.filters);
      },

      deep: true
    },
    page() {
      this.fetchContracts("no-cache", this.search, this.filters);
    },
    per_page() {
      this.fetchContracts("no-cache", this.search, this.filters);
    }
  }
};
</script>

<style scoped>
>>> .v-input__slot {
  background: transparent !important;
}

>>> .v-input__append-outer {
  width: 300px;
}

.per-page-select {
  max-width: 80px !important;
  display: inline-block;
}
</style>
